import { Button, Tooltip } from "antd";
import React, { useCallback, useRef } from "react";
import { useReactToPrint } from "react-to-print";
const RecoveryCodes = ({ recoveryCodes, verifyTheAuth }) => {
    const handleVerifyAuth = useCallback((count) => () => {
        if (verifyTheAuth) verifyTheAuth(count);
    }, [verifyTheAuth])
    const contentRef = useRef(null);
    const reactToPrintFn = useReactToPrint({
        content: () => contentRef?.current,
        onBeforeGetContent: () => {
            const style = document.createElement("style");
            style.innerHTML = `
                @media print {
                    .bg-lightBg {
                        background-color: white !important;
                    }
                    .copy-text {
                        color: black !important;
                        font-size: 14px !important;
                    }
                }
            `;
            document.head.appendChild(style);
        },
    });
    return (
        <>
            <div className="p-3.5 mt-4">
                <h4 className="text-lg font-semibold text-darkWhite text-center">Recovery Codes</h4>
                <p className="text-paraColor text-sm font-normal text-center">
                    Put these codes in a safe place. If you lose your device and don’t have the recovery codes, you will lose access to your account.
                </p>
            </div>
            <div className="flex justify-end items-center">
                <div className="text-end" onClick={reactToPrintFn}>
                    <Tooltip title={"Print"}>
                    <span className="icon printer-icon cursor-pointer"></span>
                    </Tooltip>
                </div>
            </div>
            <div ref={contentRef} className="border border-StrokeColor p-4 rounded-5 mt-2">
                <div className="grid md:grid-cols-4 gap-8 text-menuhoverColor font-medium text-base">
                    {recoveryCodes?.recoveryCodes?.map((code) => (
                        <p key={code} className="copy-text">{code}</p>
                    ))}
                </div>
            </div>
            <div className="md:flex justify-end mt-7 gap-2 space-y-3 md:space-y-0">
                <Button className='cancel-btn !py-5 md:!w-56 !w-full' key="back" onClick={handleVerifyAuth(1)}>Verify the Authenticator</Button>
                <Button className="primary-btn md:!w-40 !w-full" type="primary" htmlType="submit" onClick={handleVerifyAuth(2)}>
                    Done
                </Button>
            </div>
        </>
    );
};
export default RecoveryCodes;
